import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  SystemSettings: {
    '&__actions': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: theme.spacing(1),
      position: 'relative',
    },
    '&__button': {
      '&__add': {
        alignItems: 'center',
        display: 'flex',
      },
      '&__delete': {
        margin: 0,
        textAlign: 'center',
      },
    },
    '&__topics': {
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 10,
    },
    '&--padding-bottom': {
      paddingBottom: 25,
    },
    '&--text-align': {
      textAlign: 'center',
    },
  },
}));

export { useStyles };
